import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Button } from "reactstrap"

export default function SortBy() {
    const [searchParams, setSearchParams] = useSearchParams();

    const [orderBy, setOrderBy] = useState(searchParams.get('order_by') || 'newest');

    const handleChangeOrderBy = (order) => {
        setOrderBy(order);
        searchParams.set('order_by', order);
        searchParams.delete('page');
        setSearchParams(searchParams);
    }

    useEffect(() => {
        setOrderBy((searchParams.get('order_by') || 'newest'));
    },[searchParams])

  return (
    <>
        Sort by:
        <Button 
            onClick={(e) => handleChangeOrderBy(e.target.value)}
            value={'newest'}
            outline
            size="sm"
            className={`${'newest' == orderBy ? 'active' : ''} d-inline-block ms-2 p-1 mb-2`}
            >
            Newest
        </Button>
        <Button 
            onClick={(e) => handleChangeOrderBy(e.target.value)}
            value={'high_price'}
            outline
            size="sm"
            className={`${'high_price' == orderBy ? 'active' : ''} d-inline-block ms-2 p-1 mb-2`}
            >
            Price: Highest
        </Button>
        <Button 
            onClick={(e) => handleChangeOrderBy(e.target.value)}
            value={'lowest_price'}
            outline
            size="sm"
            className={`${'lowest_price' == orderBy ? 'active' : ''} d-inline-block ms-2 p-1 mb-2`}
            >
            Price: Lowest
        </Button>
        <Button 
            onClick={(e) => handleChangeOrderBy(e.target.value)}
            value={'relevant'}
            outline
            size="sm"
            className={`${'relevant' == orderBy ? 'active' : ''} d-inline-block ms-2 p-1 mb-2`}
            >
            Relevant
        </Button>
    </>
  )
}
